import React from 'react';
import {CustomLink, PrimaryButton} from "../../../index";
import {PrimaryButtonColor} from "../../../common/buttons/decorators/PrimaryButton/PrimaryButton";
import {RouteDictionary} from "utils";
import styles from './AccountNotReadyWarningSection.module.scss';

export enum BannerBlockVariant {
    IDENTIFICATION = 'identification',
    IDENTIFICATION_BORROWER = 'identification-borrower',
    ONBOARDING_BORROWER = 'onboarding-borrower',
    CONTRACT = 'contract',
    DEPOSIT = 'deposit',
    VERIFIED = 'verified',
    SURVEY = 'survey',
    REGISTRATION = 'registration',
}
interface Props {
    variant: BannerBlockVariant;
    params?: string
}

type IBlock = Record<BannerBlockVariant, {
    textWarning: string,
    button?: {
        route: RouteDictionary,
        text: string
    }
}>


const blockVariant: IBlock = {
  [BannerBlockVariant.IDENTIFICATION]: {
    textWarning: 'Пройдите верификацию инвестора, чтобы пользоваться услугами Платформы',
    button: {
      route: RouteDictionary.IDENTIFICATION,
      text: 'пройти'
    }
  },
  [BannerBlockVariant.IDENTIFICATION_BORROWER]: {
    textWarning: 'Пройдите верификацию заемщика, чтобы пользоваться услугами Платформы',
    button: {
      route: RouteDictionary.IDENTIFICATION_BORROWER,
      text: 'пройти'
    }
  },
  [BannerBlockVariant.ONBOARDING_BORROWER]: {
    textWarning: 'Завершите прохождение скоринг, чтобы получить доступ к личному кабинету',
    button: {
      route: RouteDictionary.IDENTIFICATION_BORROWER,
      text: 'Продолжить скоринг'
    }
  },
  [BannerBlockVariant.CONTRACT]: {
    textWarning: 'Чтобы начать инвестировать, вам необходимо подписать Агентский договор',
    button: {
      route: RouteDictionary.SIGN_CONTRACT,
      text: 'Перейти к заключению'
    }
  },
  [BannerBlockVariant.DEPOSIT]: {
    textWarning: 'Ваши данные находятся на проверке у администратора. Обычно это занимает до 1-2\n' +
            '                                    рабочих дней',
  },
  [BannerBlockVariant.VERIFIED]: {
    textWarning: 'Пополните счет, чтобы начать инвестировать в проекты',
    button: {
      route: RouteDictionary.DEPOSIT,
      text: 'на страницу пополнения'
    }
  },
  [BannerBlockVariant.SURVEY]: {
    textWarning: 'Оцените опыт работы с Conomica, опрос займет не больше 1 минуты',
    button: {
      route: RouteDictionary.SURVEY,
      text: 'Пройти опрос'
    }
  },
  [BannerBlockVariant.REGISTRATION]: {
    textWarning: 'В данный момент Регистрация не осуществляется. \n' +
            'Инвестиционная платформа ведёт подготовительные работы к запуску.',
  },
};

const BannerBlock = ({variant, params}: Props) => {
  const textWarning = blockVariant[variant].textWarning;
  const button = blockVariant[variant].button;

  return (
    <div className={styles.bannerBlock__container}>
      <div>
        {textWarning}
      </div>
      {button && <div>
        <PrimaryButton color={PrimaryButtonColor.WHITE}>
          <CustomLink to={button.route} params={{uuid: params}}>{button.text}</CustomLink>
        </PrimaryButton>
      </div>
      }
    </div>
  );
};

export default BannerBlock;